import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-211d0967"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "fr-search" };
const _hoisted_2 = { class: "fr-search-bar" };
const _hoisted_3 = { class: "fr-search-bar__row" };
const _hoisted_4 = { class: "fr-search-bar__grp" };
const _hoisted_5 = { class: "cap" };
const _hoisted_6 = ["aria-label"];
const _hoisted_7 = { class: "fr-search-bar__grp" };
const _hoisted_8 = { class: "cap" };
const _hoisted_9 = { class: "fr-party-inline" };
const _hoisted_10 = { class: "fr-fld" };
const _hoisted_11 = { class: "fr-stepper" };
const _hoisted_12 = { class: "val" };
const _hoisted_13 = ["disabled"];
const _hoisted_14 = { class: "fr-fld" };
const _hoisted_15 = { class: "fr-stepper" };
const _hoisted_16 = { class: "val" };
const _hoisted_17 = ["disabled"];
const _hoisted_18 = { class: "fr-search-bar__grp" };
const _hoisted_19 = { class: "cap" };
const _hoisted_20 = ["min", "max"];
const _hoisted_21 = {
    key: 0,
    class: "fr-childseat-row"
};
const _hoisted_22 = { class: "fr-fld" };
const _hoisted_23 = { class: "fr-stepper" };
const _hoisted_24 = { class: "val" };
const _hoisted_25 = ["disabled"];
const _hoisted_26 = { class: "fr-hint" };
const _hoisted_27 = { class: "fr-search-note" };
const _hoisted_28 = {
    key: 0,
    class: "fr-region-tabs"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = { class: "fr-tabs" };
const _hoisted_31 = ["onClick"];
const _hoisted_32 = { class: "fr-store-list" };
const _hoisted_33 = {
    key: 0,
    class: "fr-store-card__empty"
};
const _hoisted_34 = {
    key: 1,
    class: "fr-store-card__empty fr-store-card__empty--error"
};
const _hoisted_35 = {
    key: 2,
    class: "fr-store-card__empty"
};
const _hoisted_36 = { class: "fr-store-card__media" };
const _hoisted_37 = ["src"];
const _hoisted_38 = { class: "fr-store-card__body" };
const _hoisted_39 = { class: "fr-store-card__name" };
const _hoisted_40 = {
    key: 0,
    class: "fr-cap-badge"
};
const _hoisted_41 = {
    key: 1,
    class: "fr-nearest-badge"
};
const _hoisted_42 = {
    key: 0,
    class: "fr-store-card__addr"
};
const _hoisted_43 = { class: "fr-store-card__slots" };
const _hoisted_44 = {
    key: 0,
    class: "fr-store-card__empty"
};
const _hoisted_45 = {
    key: 1,
    class: "fr-store-card__empty fr-store-card__empty--error"
};
const _hoisted_46 = {
    key: 2,
    class: "fr-store-card__empty"
};
const _hoisted_47 = {
    key: 0,
    class: "fr-tchip fr-tchip--full"
};
const _hoisted_48 = ["onClick"];
const _hoisted_49 = ["onClick"];
const _hoisted_50 = {
    key: 1,
    class: "fr-pager"
};
const _hoisted_51 = ["disabled", "aria-label"];
const _hoisted_52 = ["onClick"];
const _hoisted_53 = ["disabled", "aria-label"];
const _hoisted_54 = { class: "fr-pager__count" };
import { loadAvailability, loadStores, } from '@vue/services/interval-api';
import { isEn, t } from '@vue/services/interval-lang';
import { bookingState, partySize, taipeiDateAfter, taipeiToday } from '@vue/services/interval-store';
import TomSelect from 'tom-select';
import { computed, inject, onBeforeUnmount, onMounted, ref, watch } from 'vue';
const SLOT_CAP = 8;
/** 門市分頁：每頁家數，超過才出現分頁列。 */
const PAGE_SIZE = 5;
export default /*#__PURE__*/ _defineComponent({
    __name: 'StoreSearch',
    props: {
        brandId: {}
    },
    emits: ['selectSlot'],
    setup(__props, { emit: __emit }) {
        /**
         * 門市／時段搜尋頁（原型 booking.html 的 searchView 移植）。
         *
         * 版型是 INLINE 式：上方選人數與日期，下方門市卡片內直接列出可訂時段，
         * 點時段就進入填資料，不再有獨立的「選時段」步驟。
         */
        const props = __props;
        const emits = __emit;
        /**
         * 門市卡片縮圖，路徑由 app 從 blade 帶下來（見 IntervalReservationApp 的 storeCardImage）。
         * 2026-08-26 起改用集團入口首頁那張品牌照，不再跟 banner 共用佔位圖。
         * 取不到時回退 bannerImage，卡片版面不會塌掉。
         */
        const storeCardImage = inject('storeCardImage', '');
        const bannerImage = inject('bannerImage', '');
        const cardImage = computed(() => storeCardImage || bannerImage);
        const stores = ref([]);
        const loadFailed = ref(false);
        const loaded = ref(false);
        /** 未展開時每店最多顯示的時段數，其餘收進「…」。 */
        const expanded = ref({});
        const currentRegion = ref('');
        const currentPage = ref(1);
        const activeMealWindow = ref('');
        /**
         * 門店下拉（對齊明水然・樂的「店別」）：0＝全部門市，選了就只列那一家。
         *
         * ⚠️ 這個 select 刻意不用 v-model：TomSelect 會接管原生 select，
         *    跟 v-model 搶同一個節點會互相覆蓋（CustomerForm 國碼同一個坑），
         *    改由 TomSelect 的 change 事件回寫 selectedStoreId。
         */
        const selectedStoreId = ref(0);
        let storeSelect = null;
        /**
         * 併發防呆序號。
         *
         * 人數／日期連續變動會同時有多批查詢在飛，只有最後一批算數；
         * 少了這道，慢回來的舊人數時段會蓋掉新的，客人看到坐不下的位子還能點。
         */
        let availSeq = 0;
        let availTimer;
        // ---- 最近門店（開定位才有）----
        const nearestId = ref(null);
        let geoPos = null;
        let geoApplied = false;
        /** 使用者已手動點過地區或時段 → 不再自動覆蓋他的選擇。 */
        let userInteracted = false;
        const REGION_ORDER = ['north', 'central', 'south', 'east'];
        onMounted(async () => {
            await fetchStores();
            requestNearestStore();
        });
        onBeforeUnmount(() => {
            storeSelect?.destroy();
            storeSelect = null;
        });
        // 人數／日期變動 → 依新條件重查各店可訂時段（連點以 300ms 收斂）
        watch(() => [bookingState.adult, bookingState.child, bookingState.date], () => scheduleRefresh());
        // 兒童數減少時把兒童椅收斂回上限
        watch(() => bookingState.child, (v) => {
            if (bookingState.childSeat > v) {
                bookingState.childSeat = v;
            }
        });
        async function fetchStores() {
            try {
                stores.value = await loadStores(props.brandId);
                loaded.value = true;
                clampParty();
                // 門店下拉只需要門店清單，清單一回來就建立，不可等下面的時段查詢：
                // 全門市時段要等最慢那家回來（dev 36 家約多 1.2 秒），下拉會跟著遲遲點不開
                initStoreSelect();
                await refreshAvailability();
                applyNearestStore();
            }
            catch (e) {
                loadFailed.value = true;
                loaded.value = true;
            }
        }
        /**
         * 人數上限取全門市「單筆最多客戶」的最大值。
         *
         * 人數先選、門市後選，所以這裡只能取最寬鬆的上限；
         * 各店實際容量由 intervalAvailability 依 party 過濾，坐不下的店該日就顯示無時段。
         */
        const currentMax = computed(() => {
            const caps = stores.value.map((s) => (s.maxCustomer > 0 ? s.maxCustomer : 0)).filter(Boolean);
            return caps.length ? Math.max(...caps) : 30;
        });
        const capacityNote = computed(() => t('bk.capacityNote'));
        /**
         * 日期限制比照明水然前台：可選今天起，最遠到門市設定的提前預約天數。
         * 尚未載入門市時先用 30 天，避免日期欄在 API 回來前放寬成無限遠。
         */
        const dateMin = computed(() => taipeiToday());
        const dateMax = computed(() => taipeiDateAfter(30));
        function normalizeBookingDate() {
            if (bookingState.date < dateMin.value) {
                bookingState.date = dateMin.value;
            }
            else if (bookingState.date > dateMax.value) {
                bookingState.date = dateMax.value;
            }
        }
        /**
         * 卡片上的單店人數上限標籤。
         *
         * 上面的人數選擇器取全門市最寬鬆的上限（人數先選、門市後選），
         * 客人無從得知自己挑的那家其實只收幾人，所以在卡片標出各店真值；
         * 後台沒填（0）就不顯示，寧可不寫也不要標成「單次可訂位0人」。
         */
        function storeMaxParty(s) {
            return s.maxCustomer > 0 ? t('bk.storeMaxParty', { n: s.maxCustomer }) : '';
        }
        const atMaxParty = computed(() => partySize() >= currentMax.value);
        /** 換店或上限變動時，把人數收斂到上限內（先減兒童、再減大人，至少留 1 大人）。 */
        function clampParty() {
            const max = currentMax.value;
            while (partySize() > max && bookingState.child > 0) {
                bookingState.child--;
            }
            while (partySize() > max && bookingState.adult > 1) {
                bookingState.adult--;
            }
        }
        function stepParty(type, delta) {
            if (type === 'childSeat') {
                // 兒童椅不計入人數上限，只受兒童數限制
                bookingState.childSeat = Math.min(bookingState.child, Math.max(0, bookingState.childSeat + delta));
                return;
            }
            if (delta > 0 && atMaxParty.value) {
                return;
            }
            const next = bookingState[type] + delta;
            bookingState[type] = type === 'adult' ? Math.max(1, next) : Math.max(0, next);
        }
        function scheduleRefresh() {
            window.clearTimeout(availTimer);
            availTimer = window.setTimeout(refreshAvailability, 300);
        }
        /**
         * 查全門市當日可訂時段。
         *
         * 「哪家先回來就先畫哪家」：早期版本 await Promise.all 等全部完成才畫一次，
         * 整頁等待時間等於最慢的那間門市（單店查詢約 2 秒，門市愈多愈明顯）。
         */
        async function refreshAvailability() {
            if (!stores.value.length) {
                return;
            }
            const party = partySize();
            const date = bookingState.date;
            const seq = ++availSeq;
            stores.value.forEach((s) => {
                s._slots = undefined;
            });
            await Promise.all(stores.value.map(async (s) => {
                let slots;
                try {
                    slots = await loadAvailability(s.id, date, party);
                }
                catch (e) {
                    slots = null;
                }
                // 期間已換過日期／人數 → 本次結果作廢，連寫回都不可以
                if (seq !== availSeq) {
                    return;
                }
                s._slots = slots;
            }));
        }
        // ---- 餐期 tabs：純前端依時間窗過濾，不重打 API ----
        const MEAL_TABS = [
            { win: '', label: 'bk.allDay' },
            { win: '00:00-16:00', label: 'bk.noon' },
            { win: '16:00-24:00', label: 'bk.evening' },
        ];
        function toMinutes(time) {
            const m = /^(\d{1,2}):(\d{2})/.exec(time || '');
            return m ? Number(m[1]) * 60 + Number(m[2]) : null;
        }
        const mealWindowRange = computed(() => {
            if (!activeMealWindow.value) {
                return null;
            }
            const [ws, we] = activeMealWindow.value.split('-').map(toMinutes);
            return ws == null || we == null ? null : [ws, we];
        });
        function visibleSlots(store) {
            if (!store._slots) {
                return [];
            }
            const range = mealWindowRange.value;
            const items = range
                ? store._slots.filter((it) => {
                    const m = toMinutes(it.time);
                    return m != null && m >= range[0] && m < range[1];
                })
                : store._slots;
            return expanded.value[store.id] ? items : items.slice(0, SLOT_CAP);
        }
        function hasMoreSlots(store) {
            if (!store._slots || expanded.value[store.id]) {
                return false;
            }
            const range = mealWindowRange.value;
            const items = range
                ? store._slots.filter((it) => {
                    const m = toMinutes(it.time);
                    return m != null && m >= range[0] && m < range[1];
                })
                : store._slots;
            return items.length > SLOT_CAP;
        }
        /** 篩選後一個時段都不剩（要顯示「當日無可訂時段」而不是空白）。 */
        function isSlotEmpty(store) {
            return Array.isArray(store._slots) && visibleSlots(store).length === 0;
        }
        // ---- 地區分頁 ----
        const presentRegions = computed(() => REGION_ORDER.filter((r) => stores.value.some((s) => (s.region || '') === r)));
        const regionTabs = computed(() => presentRegions.value.length ? ['', ...presentRegions.value] : []);
        function regionLabel(region) {
            return t(`rg.${region || 'all'}`);
        }
        function selectRegion(region) {
            userInteracted = true;
            currentRegion.value = region;
            // 收斂在單店時切地區 → 解除選店，改列該區全部門市（與明水然・樂一致）
            if (selectedStoreId.value) {
                selectedStoreId.value = 0;
                storeSelect?.setValue('', true);
            }
            // 換地區＝換一批門市，回到第 1 頁
            currentPage.value = 1;
        }
        /** 選了門店只留那一家；否則依地區過濾，最近店置頂。 */
        const filteredStores = computed(() => {
            if (selectedStoreId.value) {
                return stores.value.filter((s) => s.id === selectedStoreId.value);
            }
            const list = currentRegion.value
                ? stores.value.filter((s) => (s.region || '') === currentRegion.value)
                : stores.value.slice();
            if (nearestId.value) {
                const i = list.findIndex((s) => s.id === nearestId.value);
                if (i > 0) {
                    const [n] = list.splice(i, 1);
                    list.unshift(n);
                }
            }
            return list;
        });
        // ---- 門市分頁 ----
        const totalPages = computed(() => Math.max(1, Math.ceil(filteredStores.value.length / PAGE_SIZE)));
        const pagedStores = computed(() => {
            // 切地區／門市變少 → 收斂回最後一頁
            if (currentPage.value > totalPages.value) {
                currentPage.value = totalPages.value;
            }
            const start = (currentPage.value - 1) * PAGE_SIZE;
            return filteredStores.value.slice(start, start + PAGE_SIZE);
        });
        const showPager = computed(() => totalPages.value > 1);
        const pagerCount = computed(() => t('bk.pagerCount', {
            from: (currentPage.value - 1) * PAGE_SIZE + 1,
            to: Math.min(currentPage.value * PAGE_SIZE, filteredStores.value.length),
            total: filteredStores.value.length,
        }));
        function goPage(page) {
            if (page < 1 || page > totalPages.value || page === currentPage.value) {
                return;
            }
            currentPage.value = page;
            // 換頁後把門市列表捲回上緣，不要停在上一頁的捲動位置
            const el = document.querySelector('.fr-store-list');
            if (el) {
                const top = el.getBoundingClientRect().top + window.pageYOffset - 90;
                window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
            }
        }
        // ---- 門店下拉 ----
        function initStoreSelect() {
            const options = [
                { value: '', title: t('bk.storeAll') },
                ...stores.value.map((s) => ({ value: String(s.id), title: storeName(s) })),
            ];
            storeSelect = new TomSelect('#fr-store-select', {
                // 跟著清單長度走 = 全部顯示，寫死數字會在門市變多時靜默截掉
                maxOptions: options.length,
                valueField: 'value',
                labelField: 'title',
                // 只比對店名（同明水然・樂）。曾連地址一起搜，打「西」會跑出地址在西屯區、樹西里的店，
                // 下拉又看不到地址，客人會以為搜錯，2026-10-13 改回只搜店名
                searchField: ['title'],
                sortField: [{ field: '$order' }],
                create: false,
                allowEmptyOption: true,
                options,
                items: [''],
                // ⚠️ wrapperClass 是「取代」預設的 ts-wrapper，原生 class 必須留著，
                //    否則下拉（absolute）失去定位基準會飛到文件左上角
                wrapperClass: 'ts-wrapper fr-store-select',
                render: {
                    no_results: () => `<div class="fr-store-select__empty">${t('bk.storeNoResult')}</div>`,
                },
            });
            storeSelect.on('change', (value) => pickStore(Number(value) || 0));
        }
        function pickStore(id) {
            userInteracted = true;
            selectedStoreId.value = id;
            currentPage.value = 1;
            const store = id ? stores.value.find((s) => s.id === id) : undefined;
            // 地區分頁跟著亮到該店所在區；清回「全部門市」則維持原本地區
            if (store?.region && presentRegions.value.includes(store.region)) {
                currentRegion.value = store.region;
            }
        }
        // ---- 最近門店（Haversine）----
        function haversineKm(aLat, aLng, bLat, bLng) {
            const toRad = (d) => (d * Math.PI) / 180;
            const R = 6371;
            const dLat = toRad(bLat - aLat);
            const dLng = toRad(bLng - aLng);
            const s = Math.sin(dLat / 2) ** 2 +
                Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) * Math.sin(dLng / 2) ** 2;
            return 2 * R * Math.asin(Math.min(1, Math.sqrt(s)));
        }
        /** 距離差 < 50m 視為同址，改用 ordering 決定誰排前面。 */
        function findNearestStore() {
            const withGeo = stores.value.filter((s) => s.lat != null && s.lng != null);
            if (!withGeo.length || !geoPos) {
                return null;
            }
            return withGeo
                .map((s) => ({ s, d: haversineKm(geoPos.lat, geoPos.lng, Number(s.lat), Number(s.lng)) }))
                .sort((a, b) => Math.abs(a.d - b.d) > 0.05
                ? a.d - b.d
                : (Number(a.s.ordering) || 0) - (Number(b.s.ordering) || 0))[0].s;
        }
        function applyNearestStore() {
            if (geoApplied || userInteracted || !geoPos || !stores.value.length) {
                return;
            }
            const nearest = findNearestStore();
            if (!nearest) {
                return;
            }
            geoApplied = true;
            nearestId.value = nearest.id;
            if (nearest.region && presentRegions.value.includes(nearest.region)) {
                currentRegion.value = nearest.region;
            }
        }
        function requestNearestStore() {
            if (!('geolocation' in navigator)) {
                return;
            }
            navigator.geolocation.getCurrentPosition((p) => {
                geoPos = { lat: p.coords.latitude, lng: p.coords.longitude };
                applyNearestStore();
            }, 
            // 拒絕／逾時／失敗 → 不推送，維持顯示全部門市
            () => { }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 });
        }
        // ---- 顯示 ----
        /**
         * 依目前語言取門市顯示名（en 缺資料回退中文）。
         *
         * 後台建的門市 title 有的已經含品牌名（例如「肉多多 台北西門」），
         * 有的沒有。無條件加前綴會變成「肉多多 — 肉多多 台北西門」，
         * 所以已經以品牌名開頭的就直接用原字串。
         */
        function storeName(s) {
            const brand = isEn() ? 'Rododo' : '肉多多';
            const title = ((isEn() ? s.en?.title || s.tw?.title : s.tw?.title) || '').trim();
            if (!title) {
                return brand;
            }
            return title.startsWith(brand) ? title : `${brand} — ${title}`;
        }
        function storeAddress(s) {
            return s.tw?.address || s.en?.address || '';
        }
        /**
         * 用餐結束時間：API 給全時間字串，這裡取 HH:mm。
         *
         * ⚠️ 2026-08-14 起**畫面不再顯示結束時間**（門市決策，時段一律只出示開始時間），
         * 但值仍存進 bookingState.slot.end 備用；訂位送出的 payload 本來就只用 slot.time。
         */
        function slotEnd(endAt) {
            return (endAt || '').slice(11, 16);
        }
        function pickSlot(store, time, endAt) {
            userInteracted = true;
            bookingState.storeId = store.id;
            bookingState.storeName = storeName(store);
            // 訂位須知／溫馨提醒：門市清單本來就帶著這兩欄，選店時一併存下，
            // 填資料頁的彈窗才不必為了拿文字再打一次 API。
            const langKey = isEn() ? 'en' : 'tw';
            bookingState.storeInstruction = store[langKey]?.reservationInstruction ?? '';
            bookingState.storeNotice = store[langKey]?.notice ?? '';
            bookingState.slot = { time, end: slotEnd(endAt) };
            emits('selectSlot');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('bk.store')), 1),
                            _createElementVNode("select", {
                                id: "fr-store-select",
                                "aria-label": _unref(t)('bk.store')
                            }, null, 8, _hoisted_6)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('bk.partyTitle')), 1),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(t)('bk.adult')), 1),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (stepParty('adult', -1)))
                                        }, "−"),
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(bookingState).adult), 1),
                                        _createElementVNode("button", {
                                            type: "button",
                                            disabled: atMaxParty.value,
                                            onClick: _cache[1] || (_cache[1] = ($event) => (stepParty('adult', 1)))
                                        }, "＋", 8, _hoisted_13)
                                    ])
                                ]),
                                _createElementVNode("div", null, [
                                    _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(t)('bk.child')), 1),
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (stepParty('child', -1)))
                                        }, "−"),
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(bookingState).child), 1),
                                        _createElementVNode("button", {
                                            type: "button",
                                            disabled: atMaxParty.value,
                                            onClick: _cache[3] || (_cache[3] = ($event) => (stepParty('child', 1)))
                                        }, "＋", 8, _hoisted_17)
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('bk.date')), 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(bookingState).date) = $event)),
                                type: "date",
                                class: "fr-input",
                                min: dateMin.value,
                                max: dateMax.value,
                                onChange: normalizeBookingDate
                            }, null, 40, _hoisted_20), [
                                [_vModelText, _unref(bookingState).date]
                            ])
                        ])
                    ]),
                    (_unref(bookingState).child > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", null, [
                                _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(t)('bk.childSeat')), 1),
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[5] || (_cache[5] = ($event) => (stepParty('childSeat', -1)))
                                    }, "−"),
                                    _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(bookingState).childSeat), 1),
                                    _createElementVNode("button", {
                                        type: "button",
                                        disabled: _unref(bookingState).childSeat >= _unref(bookingState).child,
                                        onClick: _cache[6] || (_cache[6] = ($event) => (stepParty('childSeat', 1)))
                                    }, "＋", 8, _hoisted_25)
                                ]),
                                _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('bk.childSeatHint')), 1)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(capacityNote.value), 1)
                ]),
                (regionTabs.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionTabs.value, (r) => {
                            return (_openBlock(), _createElementBlock("button", {
                                key: r || 'all',
                                type: "button",
                                class: _normalizeClass({ on: r === currentRegion.value }),
                                onClick: ($event) => (selectRegion(r))
                            }, _toDisplayString(regionLabel(r)), 11, _hoisted_29));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_30, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(MEAL_TABS, (tab) => {
                        return _createElementVNode("button", {
                            key: tab.win,
                            type: "button",
                            class: _normalizeClass({ on: tab.win === activeMealWindow.value }),
                            onClick: ($event) => (activeMealWindow.value = tab.win)
                        }, _toDisplayString(_unref(t)(tab.label)), 11, _hoisted_31);
                    }), 64))
                ]),
                _createElementVNode("div", _hoisted_32, [
                    (!loaded.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_unref(t)('st.loading')), 1))
                        : (loadFailed.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_unref(t)('st.fail')), 1))
                            : (!stores.value.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_unref(t)('st.empty')), 1))
                                : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagedStores.value, (s) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: s.id,
                            class: "fr-store-card"
                        }, [
                            _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("img", {
                                    src: cardImage.value,
                                    alt: ""
                                }, null, 8, _hoisted_37)
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                    _createTextVNode(_toDisplayString(storeName(s)) + " ", 1),
                                    (storeMaxParty(s))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(storeMaxParty(s)), 1))
                                        : _createCommentVNode("", true),
                                    (s.id === nearestId.value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_unref(t)('bk.nearest')), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                (storeAddress(s))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, "📍 " + _toDisplayString(storeAddress(s)), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_43, [
                                    (s._slots === undefined)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_unref(t)('bk.slotLoading')), 1))
                                        : (s._slots === null)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_unref(t)('bk.slotFail')), 1))
                                            : (isSlotEmpty(s))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_unref(t)('bk.slotEmpty')), 1))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleSlots(s), (it) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                            key: it.time
                                                        }, [
                                                            (!it.available)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                                                                    _createTextVNode(_toDisplayString(it.time), 1),
                                                                    _createElementVNode("small", null, _toDisplayString(_unref(t)('bk.slotFull')), 1)
                                                                ]))
                                                                : (_openBlock(), _createElementBlock("button", {
                                                                    key: 1,
                                                                    type: "button",
                                                                    class: "fr-tchip",
                                                                    onClick: ($event) => (pickSlot(s, it.time, it.end_at))
                                                                }, _toDisplayString(it.time), 9, _hoisted_48))
                                                        ]));
                                                    }), 128)),
                                                    (hasMoreSlots(s))
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            type: "button",
                                                            class: "fr-tchip fr-tchip--more",
                                                            onClick: ($event) => (expanded.value[s.id] = true)
                                                        }, "…", 8, _hoisted_49))
                                                        : _createCommentVNode("", true)
                                                ], 64))
                                ])
                            ])
                        ]));
                    }), 128))
                ]),
                (showPager.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createElementVNode("button", {
                            type: "button",
                            disabled: currentPage.value === 1,
                            "aria-label": _unref(t)('bk.pagerPrev'),
                            onClick: _cache[7] || (_cache[7] = ($event) => (goPage(currentPage.value - 1)))
                        }, "‹", 8, _hoisted_51),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (p) => {
                            return (_openBlock(), _createElementBlock("button", {
                                key: p,
                                type: "button",
                                class: _normalizeClass({ on: p === currentPage.value }),
                                onClick: ($event) => (goPage(p))
                            }, _toDisplayString(p), 11, _hoisted_52));
                        }), 128)),
                        _createElementVNode("button", {
                            type: "button",
                            disabled: currentPage.value === totalPages.value,
                            "aria-label": _unref(t)('bk.pagerNext'),
                            onClick: _cache[8] || (_cache[8] = ($event) => (goPage(currentPage.value + 1)))
                        }, "›", 8, _hoisted_53),
                        _createElementVNode("div", _hoisted_54, _toDisplayString(pagerCount.value), 1)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
